import { Dashboard } from "@/components/dashboard/dashboard";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_app/")({
  component: Dashboard,
  head: () => ({ meta: [{ title: "Papier - Overview" }] }),
  validateSearch: z.object({
    plan: z.literal("pro").optional(),
  }),
  beforeLoad: async ({ search }) => {
    const { plan } = search;
    if (plan) {
      throw redirect({
        to: "/organization/billing",
        search: { plan },
      });
    }
  },
});
